export const getRewardDateCountdown = (dateCountdown, expiryTagThresholdInDays) => {
    if (expiryTagThresholdInDays === undefined || !dateCountdown)
        return;
    if (expiryTagThresholdInDays >= dateCountdown.days)
        return dateCountdown;
};
